import gql from 'graphql-tag';

export default gql`
query queryMyPublishedApps {
  queryMyPublishedApps {
    items {
      uuid
      app {
        uuid
        user
        lang    # Publisher language (deduced from preferences/browser)

        data

        tag1
        tag2
        tag3
        tag4
        tag5

        stats {
          mnth
          currency
          users
          amount
        }
      }
    }
  }
}
`;
